import React, { Component } from "react";
import "./DotCommand.css";
import "../Styles/SvgCommand.css";

export default function DotCommand(props) {
  return (
    <svg
      name="dotCommand"
      className={
        props.isStandard & props.isShow
          ? "svg"
          : props.isShow
          ? "dot"
          : "isClose"
      }
    >
      <rect x="5" y="10" width="2" height="2" fill={props.color} />
      <rect x="10" y="10" width="2" height="2" fill={props.color} />
      <rect x="15" y="10" width="2" height="2" fill={props.color} />
    </svg>
  );
}
